import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { trackCTAClick } from '../services/analytics'
import { bandasAPI } from '../services/api'
import {
  Box,
  Container,
  Heading,
  Text,
  Button,
  VStack,
  SimpleGrid,
  Image,
  HStack,
} from '@chakra-ui/react'
import EntityLogoImage from './EntityLogoImage.jsx'

const CommunityLandingSection = () => {
  const navigate = useNavigate()
  const [bandas, setBandas] = useState([])

  useEffect(() => {
    let cancelled = false
    bandasAPI
      .getAll({})
      .then((res) => {
        const list = res.data?.data || res.data || []
        const mapped = (Array.isArray(list) ? list : [])
          .filter((b) => b?.nombre)
          .slice(0, 4)
          .map((b) => ({
            id: b.id,
            name: b.nombre,
            location: b.localizacion?.ciudad || b.ciudad || '',
            image: b.avatar || '/banda-background.jpg',
          }))
        if (!cancelled) setBandas(mapped)
      })
      .catch(() => {
        if (!cancelled) setBandas([])
      })
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <Box py={{ base: 14, md: 20 }} bg="gray.50" borderTopWidth="1px" borderColor="gray.100" data-landing="comunidad">
      <Container maxW="6xl">
        <VStack gap={{ base: 8, md: 10 }} align="stretch">
          <SimpleGrid columns={{ base: 1, md: 2 }} gap={{ base: 8, md: 12 }} alignItems="center">
            <Box display="flex" justifyContent="center">
              <Image
                src="/capirote registro.png"
                alt=""
                maxW={{ base: '240px', sm: '280px', md: '320px' }}
                w="full"
                h="auto"
                objectFit="contain"
                css={{ filter: 'drop-shadow(0 16px 32px rgba(124, 58, 237, 0.18))' }}
              />
            </Box>

            <VStack
              gap={4}
              textAlign={{ base: 'center', md: 'left' }}
              align={{ base: 'center', md: 'flex-start' }}
            >
              <Heading as="h2" fontSize={{ base: '2xl', md: '3xl' }} fontWeight="800" color="gray.800">
                También, la comunidad
              </Heading>
              <Text fontSize={{ base: 'md', md: 'lg' }} color="gray.600" lineHeight="tall" maxW="2xl">
                La comunidad es nuestra meta en Cadencya.
                Comparte comunidad con cientos de bandas y entidades religiosas. Espera a ser contactado y a cerrar actuaciones. 
                Gestiona tu banda mientras las entidades religiosas se fijan en ti.
              </Text>
              <Button
                size="lg"
                colorPalette="purple"
                rounded="full"
                px={10}
                py={7}
                fontWeight="bold"
                onClick={() => {
                  trackCTAClick('comunidad', 'landing_community_section')
                  navigate('/comunidad')
                }}
              >
                Ir a la comunidad
              </Button>
            </VStack>
          </SimpleGrid>

          {bandas.length > 0 ? (
            <SimpleGrid columns={{ base: 1, sm: 2, lg: 4 }} gap={4}>
              {bandas.map((banda) => (
                <Box
                  key={banda.id}
                  bg="white"
                  rounded="2xl"
                  overflow="hidden"
                  borderWidth="1px"
                  borderColor="gray.200"
                >
                  <EntityLogoImage
                    src={banda.image}
                    alt={banda.name || ''}
                    name={banda.name}
                    h="140px"
                    w="full"
                    circleSize="96px"
                  />
                  <Box p={4}>
                    <Text fontWeight="800" color="gray.800" lineClamp={2}>
                      {banda.name}
                    </Text>
                    {banda.location ? (
                      <Text fontSize="sm" color="gray.500" mt={1}>
                        {banda.location}
                      </Text>
                    ) : null}
                  </Box>
                </Box>
              ))}
            </SimpleGrid>
          ) : (
            <HStack
              bg="white"
              rounded="2xl"
              borderWidth="1px"
              borderColor="gray.200"
              p={{ base: 6, md: 8 }}
              gap={6}
              flexDirection={{ base: 'column', md: 'row' }}
            >
              <Box flex={1}>
                <Text fontWeight="700" color="gray.800" mb={2}>
                  Directorio público
                </Text>
                <Text color="gray.600" fontSize="sm">
                  Entra en Comunidad para ver bandas y entidades con perfil publicado.
                </Text>
              </Box>
            </HStack>
          )}
        </VStack>
      </Container>
    </Box>
  )
}

export default CommunityLandingSection
